<template>
  <input class="btn btn-outline-success btn-block" type="submit" value="Login">
</template>

<script>
export default {
  name: 'FormSubmit'
}
</script>




// WEBPACK FOOTER //
// src/components/FormSubmit.vue